import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class CommonService {
    isExpanded: Subject<boolean> = new Subject();
    constructor(private dataService: DataService) {
    }
    url = environment.api_base_url;
    menuExpandCollapse(flag: boolean) {
        //this.isExpanded = false;
    }
}